import React, { useContext, useEffect, useMemo, useState } from 'react'
import { Link } from 'react-router-dom'
import styles from './HomeLink.module.css'
import { UserContext } from '../../../context/UserContext.tsx'
import { participantApiV1 } from '../../../api.ts'

const HomeLink: React.FC = () => {
  const context = useContext(UserContext)
  if (!context) {
    throw new Error('UserHeader must be used within a UserProvider')
  }
  const { currentUser } = context
  const [button1, setButton1] = useState('')
  const [button2, setButton2] = useState('')
  const [button3, setButton3] = useState('https://er.ru/upages/custom-agreement')
  const domain = window.location.hostname

  const details = useMemo(() => {
    return (
      domain !== 'er-contributions.ru' &&
      domain !== 'www.er-contributions.ru' &&
      domain !== 'v2.er-contributions.ru'
    )
  }, [domain])

  const fetchButtons = async () => {
    await participantApiV1
      .get(`/participants/region-buttons/${currentUser?.ro_id}`)
      .then((response) => {
        const { button1, button2, button3 } = response.data
        if (button1) setButton1(button1)
        if (button2) setButton2(button2)
        setButton3(button3 || 'https://er.ru/upages/custom-agreement')
      })
  }

  useEffect(() => {
    fetchButtons()
  })

  return (
    <div className="grid grid-cols-2 gap-3">
      <a
        href={button1}
        target="_blank"
        rel="noopener noreferrer"
        className={`h-full ${!button1 ? 'opacity-70 pointer-events-none cursor-not-allowed' : ''}`}
      >
        <div className={styles.btnLink}>
          <div>
            <i className="fas fa-random"></i>
          </div>
          <div>Инструкция по оплате</div>
        </div>
      </a>

      <a
        href={button2}
        target="_blank"
        rel="noopener noreferrer"
        className={`h-full ${!button2 ? 'opacity-70 pointer-events-none cursor-not-allowed' : ''}`}
      >
        <div className={styles.btnLink}>
          <div>
            <i className="fas fa-random"></i>
          </div>
          <div>Порядок уплаты членских взносов</div>
        </div>
      </a>

      <a href={button3} target="_blank" rel="noopener noreferrer" className={'col-span-2'}>
        <div className={styles.btnLink}>
          <div>
            <i className="fas fa-file-contract"></i>
          </div>
          <div>Пользовательское соглашение</div>
        </div>
      </a>

      {details && (
        <Link to="/contact" style={{ gridColumn: 'span 2 / span 2', textAlign: 'center' }}>
          <div className={styles.btnLink}>
            <div>Контакты</div>
          </div>
        </Link>
      )}
    </div>
  )
}

export default HomeLink
